/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { connect, Dispatch } from "react-redux";
import { IAppState } from "../models/IAppState";
import { InterventionsSummary } from "../components/Interventions/InterventionsSummary";
import { InterventionsActions } from "../actions/IntervantionsActions";
import { IFetchScheduledInterventionsProgressRequest, IFetchScheduledInterventionsProgresssResponse, IFetchScheduledInterventionsRequest, IFetchScheduledInterventionsResponse } from "../models/IFetchScheduledInterventions";
import { groupBy } from "lodash"
import { InterventionsDailyView } from "../components/Interventions/InterventionsDailyView";
import AppUtils from "../utils/AppUtils";
import { IDayEpochInfo } from "../models/util/IDayEpochInfo";
import { interventionsContainerStyles } from "../styles/Interventions/interventionsContainer";
import { InterventionsHistory } from "../components/Interventions/IntervantionsHistory";
import { Card } from "../components/common/Card";
import { IPatientDetail } from "@curefit/care-common";





interface IIntervantionsProps {
    patientProfile: IPatientDetail,
    showHeader?: boolean
}

interface IIntervantionsState {
    summaryData: IFetchScheduledInterventionsProgresssResponse[];
    dailyViewData: Array<IFetchScheduledInterventionsResponse>;
    historyData: Array<IFetchScheduledInterventionsResponse[]>;
    startDate: number;
    endDate: number;
    dateList: IDayEpochInfo[],
    dailyViewStartDate: number;
    dailyViewEndDate: number;
    dailyViewdateList: IDayEpochInfo[];
    isMobile: boolean;
}


interface IIntervantionsPropsFromDispatch {
    fetchSummary(data: IFetchScheduledInterventionsProgressRequest, patientId: string): Promise<IFetchScheduledInterventionsProgresssResponse[]>;
    getDailyViewData(data: IFetchScheduledInterventionsRequest): Promise<Array<IFetchScheduledInterventionsResponse>>;
    getScheduledInterventionsHistory(patientId: string): Promise<Array<IFetchScheduledInterventionsResponse[]>>;
}

class InterventionsContainerComponent extends React.Component<IIntervantionsProps & IIntervantionsPropsFromDispatch, IIntervantionsState>{
    constructor(props: IIntervantionsProps & IIntervantionsPropsFromDispatch) {
        super(props);
        const endDate = new Date().setHours(0, 0, 0, 0);
        const startDate = endDate - (7 * 24 * 60 * 60 * 1000);
        const dateList = AppUtils.getListOfDays(startDate, endDate);
        this.state = {
            summaryData: null,
            dailyViewData: null,
            historyData: null,
            dailyViewStartDate: startDate,
            dailyViewEndDate: endDate,
            dailyViewdateList: dateList,
            startDate,
            endDate,
            dateList,
            isMobile: AppUtils.getIsMobile()
        };
        this.dateRangeChangeHandler = this.dateRangeChangeHandler.bind(this);
        this.onDailyViewBack = this.onDailyViewBack.bind(this);
        this.onDailyViewFwd = this.onDailyViewFwd.bind(this);
    }
    componentDidMount() {
        this.fetchData();
    }

    private fetchData() {
        this.fetchSummaryData();
        this.fetchDailyViewData();
        this.fetchHistoryData();
    }

    private dateRangeChangeHandler(startDate: number, endDate: number): void {
        const dateList = AppUtils.getListOfDays(startDate, endDate);
        this.setState({ startDate, endDate, dateList }, () => {
            this.fetchSummaryData();
        });
    }

    private fetchSummaryData(): void {
        const { startDate, endDate } = this.state;
        const interventionsSummaryReqData: IFetchScheduledInterventionsProgressRequest = {
            "dateRangeList": [
                {
                    "fromDateEpoch": startDate,
                    "toDateEpoch": endDate
                }
            ]
        }
        this.props.fetchSummary(interventionsSummaryReqData, `${this.props.patientProfile.id}`)
            .then(summaryData => {
                this.setState({ summaryData });
            }).catch(console.error)
    }

    private fetchDailyViewData(): void {
        const { dailyViewStartDate, dailyViewEndDate } = this.state;
        const interventionsSummaryReqData: IFetchScheduledInterventionsRequest = {
            dateRange: {
                "fromDateEpoch": dailyViewStartDate,
                "toDateEpoch": dailyViewEndDate
            },
            patientId: this.props.patientProfile.id
        };
        this.props.getDailyViewData(interventionsSummaryReqData)
            .then(dailyViewData => {
                this.setState({ dailyViewData });
            }).catch(console.error)
    }

    private fetchHistoryData() {
        this.props.getScheduledInterventionsHistory(`${this.props.patientProfile.id}`)
            .then(historyData => {
                // console.log(historyData);
                this.setState({ historyData });

            })
            .catch(console.error);
    }

    private onDailyViewBack(): void {

        let { dailyViewEndDate, dailyViewStartDate } = this.state;
        const epochInWeek: number = (7 * 24 * 60 * 60 * 1000);
        dailyViewStartDate = dailyViewStartDate - epochInWeek;
        dailyViewEndDate = dailyViewEndDate - epochInWeek;
        const dailyViewdateList = AppUtils.getListOfDays(dailyViewStartDate, dailyViewEndDate);
        this.setState({ dailyViewStartDate, dailyViewEndDate, dailyViewdateList }, () => {
            this.fetchDailyViewData();
        })

    }

    private onDailyViewFwd(): void {
        let { dailyViewEndDate, dailyViewStartDate } = this.state;
        const epochInWeek: number = (7 * 24 * 60 * 60 * 1000);
        dailyViewStartDate = dailyViewStartDate + epochInWeek;
        dailyViewEndDate = dailyViewEndDate + epochInWeek;
        const dailyViewdateList = AppUtils.getListOfDays(dailyViewStartDate, dailyViewEndDate);
        this.setState({ dailyViewStartDate, dailyViewEndDate, dailyViewdateList }, () => {
            this.fetchDailyViewData();
        })
    }

    private groupDailyViewData(dailyViewData: IFetchScheduledInterventionsResponse[]) {
        if (!dailyViewData)
            return {};
        const groupedData = groupBy(dailyViewData, (data) => data.lineItem.interventionId);
        console.log(groupedData);
        return groupedData;
    }

    render() {
        const { summaryData, startDate, endDate, dateList, dailyViewData, historyData, dailyViewdateList, isMobile } = this.state;
        const { showHeader } = this.props;
        return (<div>
            {!isMobile && showHeader !== false && <Card>
                <div css={interventionsContainerStyles.header}>Interventions</div>
            </Card>
            }
            <InterventionsSummary data={summaryData} startDate={startDate} endDate={endDate} dateRangeChangeHandler={this.dateRangeChangeHandler} isMobile={isMobile} />
            <InterventionsDailyView dateList={dailyViewdateList} data={this.groupDailyViewData(dailyViewData)} onDailyViewBack={this.onDailyViewBack} onDailyViewFwd={this.onDailyViewFwd} isMobile={isMobile} />
            <InterventionsHistory historyData={historyData} isMobile={isMobile} />
        </div>)
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): IIntervantionsProps => {
    return {
        patientProfile: state.patientCompleteInfo.profile,
        showHeader: ownProps.showHeader
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        fetchSummary: (data: IFetchScheduledInterventionsProgressRequest, patientId: string) => InterventionsActions.getIntervantionsSummary(data, patientId),
        getDailyViewData: (data: IFetchScheduledInterventionsRequest) => InterventionsActions.getDailyViewData(data),
        getScheduledInterventionsHistory: (patientId: string) => InterventionsActions.getScheduledInterventionsHistory(patientId)

    };
}

export const InterventionsContainer = connect(mapStateToProps, mapDispatchToProps)(InterventionsContainerComponent);